import { NU_TO_PU, PU_TO_NU } from "../constants";
import PdfDocMapper from "../mapper/PdfDocMapper";
import { TransformParameters } from "../structures";
import generateNprojFromDocMapper from "./generateNprojFromDocMapper";
export function generateNProjFromPdf(pdf, startSobp, ncodePadding) {
    const mi = new PdfDocMapper(pdf.filename, 1, pdf.fingerprint, null);
    for (let pgIdx = 0; pgIdx < pdf.numPages; pgIdx++) {
        const page = pdf.getPage(pgIdx + 1);
        const width_pu = page.viewport.width;
        const height_pu = page.viewport.height;
        const width_nu = width_pu * PU_TO_NU;
        const height_nu = width_pu * PU_TO_NU;
        const npageArea = [
            { x: ncodePadding.x_nu, y: ncodePadding.y_nu },
            { x: ncodePadding.x_nu + width_nu, y: ncodePadding.y_nu },
            { x: ncodePadding.x_nu + width_nu, y: ncodePadding.y_nu + height_nu },
            { x: ncodePadding.x_nu, y: ncodePadding.y_nu + height_nu },
        ];
        const pdfArea = [
            { x: 0, y: 0 },
            { x: width_pu, y: 0 },
            { x: width_pu, y: height_pu },
            { x: 0, y: height_pu },
        ];
        const { h, h_rev } = getH(npageArea, pdfArea, ncodePadding);
        const pdfDesc = {
            url: pdf.url,
            filename: pdf.filename,
            fingerprint: pdf.fingerprint,
            /** POD id = fingerprint + "/" + pagesPerSheet */
            id: pdf.fingerprint + "/1",
            numPages: pdf.numPages,
            pageNo: pgIdx + 1,
            size_pu: { width: width_pu, height: height_pu }
        };
        const item = {
            /** 인쇄된 Ncode page information */
            pageInfo: Object.assign(Object.assign({}, startSobp), { page: startSobp.page + pgIdx }),
            /** 인식되어 구분되는 base pageInfo */
            basePageInfo: Object.assign(Object.assign({}, startSobp), { page: startSobp.page + pgIdx }),
            pdfPageNo: pgIdx + 1,
            npageArea,
            pdfDesc,
            h, h_rev,
        };
        mi.push(item);
    }
    mi.makeSummary();
    const ret = generateNprojFromDocMapper(mi);
    return ret;
}
function getH(src, dst, ncodePadding) {
    const ncode_xy_to_pdf_xy = (pt) => {
        const x_nu = pt.x - ncodePadding.x_nu;
        const y_nu = pt.y - ncodePadding.y_nu;
        return { x: x_nu * NU_TO_PU, y: y_nu * NU_TO_PU };
    };
    const ncodePts = [{ x: 10, y: 10 }, { x: 100, y: 10 }, { x: 100, y: 100 }, { x: 10, y: 100 }];
    const pdfPts = ncodePts.map(pt => ncode_xy_to_pdf_xy(pt));
    const h = TransformParameters.solveNuToPuHomography(ncodePts, pdfPts);
    const h_rev = TransformParameters.solveNuToPuHomography(pdfPts, ncodePts);
    return { h, h_rev };
}
//# sourceMappingURL=generateNprojFromPdf.js.map